import React from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import * as commonStyles from "../commonStyles/commonStyles.module.css";
import { FormattedText } from "../FormattedText";
import * as styles from "./DashboardHeader.module.css";

type DashboardHeaderProps = Readonly<{
  title: string;
  mainSubtitle?: string;
  subtitle?: string;
  isFormatRequired?: boolean;
}>;

export const DashboardHeader = ({
  title,
  mainSubtitle,
  subtitle,
  isFormatRequired,
}: DashboardHeaderProps) => (
  <Row className={commonStyles.container}>
    <Column>
      <h1>{title}</h1>
      {mainSubtitle && (
        <p className={styles.middle}>
          <b>{mainSubtitle}</b>
        </p>
      )}
      {subtitle &&
        (isFormatRequired ? <FormattedText text={subtitle}></FormattedText> : <p>{subtitle}</p>)}
    </Column>
  </Row>
);
